export default __webpack_public_path__ + "static/media/qr-code-scan-lightgray2.7bc8910a.png";